import { APP_FILTER } from "@nestjs/core";
import { ApiProperty } from "@nestjs/swagger";


export class VendorReportDto {

    @ApiProperty()
    fromDate: any | string;

    @ApiProperty()
    toDate: any | string;
}